import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { DemandedDocumentsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
};

export const schemaLoanRequestResolver_GetDemandedDocuments = DemandedDocumentsTableDefinitionZod.extend({
    // documents that were demanded and have been provided by the applicant in the meantime;
    // optional so that existing consumers and mocks without the field stay valid
    providedDocuments: DemandedDocumentsTableDefinitionZod.shape.documents.optional(),
}).nullable();

export type SchemaLoanRequestResolver_GetDemandedDocuments = z.infer<
    typeof schemaLoanRequestResolver_GetDemandedDocuments
>;

export type LoanRequestResolver_GetDemandedDocuments = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetDemandedDocuments
>;
